export default __webpack_public_path__ + "static/media/ic_usdt_24.a91e20ab.svg";